import React from 'react';
import PropTypes from 'prop-types';
import { Users, Euro, Utensils, Ticket } from 'lucide-react';
import { useAdmin } from './AdminHooks';
import { cn } from '../../lib/utils';
import { Carousel, CarouselContent, CarouselItem } from '../ui/carousel';

const StatInline = ({ icon: Icon, label, value }) => null;

const ModernAdminHeader = ({ className }) => {
  const { stats, clients, events } = useAdmin();

  const headerStats = [];
  const messages = [
    stats?.totalReservations ? `Réservations: ${stats.totalReservations}` : null,
    stats?.totalGuests ? `Invités: ${stats.totalGuests}` : null,
    Number.isFinite(stats?.totalRevenue) ? `Revenu: ${stats.totalRevenue}€` : null,
    (events?.length ? `Éditions: ${events.length}` : null),
    (clients?.total ? `Clients: ${clients.total}` : null),
  ].filter(Boolean);
  const [api, setApi] = React.useState(null);
  React.useEffect(() => {
    if (!api) return;
    const id = setInterval(() => {
      try { api.scrollNext(); } catch {}
    }, 3500);
    return () => clearInterval(id);
  }, [api]);

  return (
    <header className={cn(
      "sticky top-0 z-50 border-b backdrop-blur-lg bg-slate-900/80 border-slate-700/50",
      "supports-[backdrop-filter]:bg-slate-900/60",
      className
    )}>
      <div className="px-4 py-3 w-full sm:px-6 lg:px-8">
        <div className="text-sm text-center text-slate-400">
          {messages.length ? (
            <Carousel opts={{ loop: true }} setApi={setApi} className="mx-auto max-w-full">
              <CarouselContent>
                {messages.map((m, i) => (
                  <CarouselItem key={i}>
                    <div className="px-2 py-1 text-white/80">{m}</div>
                  </CarouselItem>
                ))}
              </CarouselContent>
            </Carousel>
          ) : null}
        </div>
      </div>
    </header>
  );
};

ModernAdminHeader.propTypes = {
  className: PropTypes.string,
};

export default ModernAdminHeader;
